<template>
  <div class="image-container">
    <img
      :style="'width:' + imageWidth + '; height: ' + imageHeight"
			style="    border: 1px solid;"
      :src="imageSrc"
      alt="Resim"
      class="image"
    />

    <!-- Oklar için SVG elemanları -->
    <svg
      class="arrows"
      xmlns="http://www.w3.org/2000/svg"
      :width="imageWidth"
      :height="imageHeight"
      viewBox="0 0 500 500"
    >
      <line
        v-for="(marker, index) in markers"
        :key="index"
        :x1="marker.x1"
        :y1="marker.y1"
        :x2="marker.x2"
        :y2="marker.y2"
        stroke="#fe6d73"
        stroke-width="6"
        :marker-end="'url(#arrowhead' + index + indexLc + ')'"
        class="moving-arrow"
        @click="showMarkerInfo(marker)"
      />

      <!-- Her bir ok ucu için benzersiz bir id ile marker tanımları -->
      <defs @click="showMarkerInfo(marker)">
        <marker
          @click="showMarkerInfo(marker)"
          v-for="(marker, index) in markers"
          :key="'marker-' + index + indexLc"
          :id="'arrowhead' + index + indexLc"
          markerWidth="10"
          markerHeight="7"
          refX="5"
          refY="3.5"
          orient="auto"
        >
          <polygon points="0 0, 10 3.5, 0 7" fill="#fe6d73" />
        </marker>
      </defs>
    </svg>

    <vs-card v-if="selectedMarker" class="marker-info">
      <p>{{ selectedMarker.info }}</p>

      <b-button
        style="border-color: white"
        v-on:click="closeMarkerInfo()"
        class="vs-con-loading__container bg-danger"
        id="loading-stock-list"
        size="sm"
      >
        {{ $t("Close") }}
      </b-button>
    </vs-card>
  </div>
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    imageWidth: {
      type: String,
      default: "100%",
    },
    imageHeight: {
      type: String,
      default: "auto",
    },
    markers: {
      type: Array,
      required: true,
    },
    indexLc: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedMarker: null,
    };
  },
  methods: {
    showMarkerInfo(marker) {
      console.log("inn");
      this.selectedMarker = marker;
    },
    closeMarkerInfo() {
      this.selectedMarker = null;
    },
  },
};
</script>

<style scoped>
.image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.image {
  width: 100%;
}

/* SVG arrows positioning */
.arrows {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  z-index: 5; /* Bring SVG above other elements */
  overflow: visible; /* Ensure all markers are visible */
}

/* Animations and hover cursor */
@keyframes moveArrow {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(10px, 0px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.moving-arrow {
  animation: moveArrow 2s ease-in-out infinite alternate;
  cursor: pointer; /* Changes cursor to pointer on hover */
  pointer-events: all;
}

.overlay {
  position: absolute;
  width: 20px; /* Clickable area size */
  height: 20px;
  background-color: transparent;
  cursor: pointer;
  z-index: 10;
  pointer-events: all;
}

.marker {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #fe6d73;
  border-radius: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
}

.marker-info {
  position: absolute;
  background-color: white;
  max-width: 150px;
  font-weight: 700;
  padding: 10px;
  top: 10px;
  left: 10px;
  z-index: 10;
}
</style>
